// Russian date/time formatters. Pulled out of components so the same
// shape is used everywhere (lists, activity rail, comment timestamps).

const ONE_MINUTE_MS = 60_000;
const ONE_HOUR_MIN = 60;
const ONE_DAY_HOURS = 24;
const ONE_WEEK_DAYS = 7;

const parseDate = (raw?: string | null) => {
  if (!raw) return null;
  const date = new Date(raw);
  return Number.isNaN(date.getTime()) ? null : date;
};

export const formatTimeOnly = (raw?: string | null) => {
  const date = parseDate(raw);
  if (!date) return raw ?? '';
  return date.toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit' });
};

export const formatShortDateTime = (raw?: string | null) => {
  const date = parseDate(raw);
  if (!date) return raw ?? '—';
  const options: Intl.DateTimeFormatOptions = {
    day: 'numeric',
    month: 'short',
    hour: '2-digit',
    minute: '2-digit',
  };
  if (date.getFullYear() !== new Date().getFullYear()) {
    options.year = 'numeric';
  }
  return date.toLocaleString('ru-RU', options);
};

export const formatFullDateTime = (raw?: string | null) => {
  const date = parseDate(raw);
  if (!date) return raw ?? '—';
  return date.toLocaleString('ru-RU', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
};

export const formatRelativeTimeWithClock = (raw?: string | null) => {
  const date = parseDate(raw);
  if (!date) return raw ?? '';

  const diffMin = Math.floor((Date.now() - date.getTime()) / ONE_MINUTE_MS);
  if (diffMin < 1) return 'только что';
  if (diffMin < ONE_HOUR_MIN) return `${diffMin} мин. · ${formatTimeOnly(raw)}`;

  const diffHours = Math.floor(diffMin / ONE_HOUR_MIN);
  if (diffHours < ONE_DAY_HOURS) return `${diffHours} ч. · ${formatTimeOnly(raw)}`;

  const diffDays = Math.floor(diffHours / ONE_DAY_HOURS);
  if (diffDays < ONE_WEEK_DAYS) return `${diffDays} дн. · ${formatTimeOnly(raw)}`;

  return formatShortDateTime(raw);
};
